<div class="content-container">
  <div class="content">
    @if (supervisorReports && supervisorReports.length > 0) {
    <div class="mb-3">
      <form [formGroup]="supervisorForm">
        <div class="fw-bold mb-1">
          <label>
            <mwp-text-translate text="Supervisor Reports:" jsonKey="supervisorReports" />
          </label>
        </div>
        <div class="d-inline-flex w-100">
          <div class="col-6">
            <mwp-dropdown [form]="supervisorForm" nameForControl="reportID" [data]="supervisorReports" keyText="displayName" keyValue="reportID" />
          </div>
          <div class="col-6 ps-3align-self-center">
            <button class="mwp-button" [disabled]="!supervisorForm.valid">
              <mwp-text-translate text="Run Selected Report" jsonKey="runSelectedReport" />
            </button>
          </div>
        </div>
      </form>
    </div>
    }
    @if (fieldAgentReports && fieldAgentReports.length > 0) {
    <div class="mb-3">
      <form [formGroup]="fieldAgentForm">
        <div class="fw-bold mb-1">
          <label>
            <mwp-text-translate text="Field Agent Reports:" jsonKey="fieldAgentReports" />
          </label>
        </div>
        <div class="d-inline-flex w-100">
          <div class="col-6">
            <mwp-dropdown [form]="fieldAgentForm" nameForControl="reportID" [data]="fieldAgentReports" keyText="displayName" keyValue="reportID" />
          </div>
          <div class="col-6 ps-3 align-self-center">
            <button class="mwp-button" [disabled]="!fieldAgentForm.valid" (click)="runReport(fieldAgentForm)">
              <mwp-text-translate text="Run Selected Report" jsonKey="runSelectedReport" />
            </button>
          </div>
        </div>
      </form>
    </div>
    }
    @if (administratorReports && administratorReports.length > 0) {
    <div class="mb-3">
      <form [formGroup]="administratorForm">
        <div class="fw-bold mb-1">
          <label>
            <mwp-text-translate text="Adminstrator Reports:" jsonKey="adminstratorReports" />
          </label>
        </div>
        <div class="d-inline-flex w-100">
          <div class="col-6">
            <mwp-dropdown [form]="administratorForm" nameForControl="reportID" [data]="administratorReports" keyText="displayName" keyValue="reportID" />
          </div>
          <div class="col-6 ps-3 align-self-center">
            <button class="mwp-button" [disabled]="!administratorForm.valid">
              <mwp-text-translate text="Run Selected Report" jsonKey="runSelectedReport" />
            </button>
          </div>
        </div>
      </form>
    </div>
    }
    @if (companyReports && companyReports.length > 0) {
    <div class="pb-3">
      <form [formGroup]="companyForm">
        <div class="fw-bold mb-3">
          <label>
            <mwp-text-translate text="Company Reports:" jsonKey="companyReports" />
          </label>
        </div>
        <div class="d-inline-flex w-100">
          <div class="col-6">
            <mwp-dropdown [form]="companyForm" nameForControl="reportID" [data]="companyReports" keyText="displayName" keyValue="reportID" labelName="Company Reports:" />
          </div>
          <div class="col-6 ps-3 align-self-center">
            <button class="mwp-button" [disabled]="!companyForm.valid" (click)="runReport(companyForm)">
              <mwp-text-translate text="Run Selected Report" jsonKey="runSelectedReport" />
            </button>
          </div>
        </div>
      </form>
    </div>
    }
  </div>
</div>